<div class="col-xl-4 col-lg-6 col-md-6 grid-item case3">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/reactjs/react-720-X-720-2.webp" alt="case image">
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">I2Rportal</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case3">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/reactjs/React-720-X-720-11.jpg" alt="case image">
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">We Teach</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case3">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/reactjs/React-720-X-720-12.jpg" alt="case image">
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Elemental</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>